'use client';

import React, { useState } from 'react';
import NavBar from '@/components/header/NavBar';
import Why from '@/components/whySection';
import { FaAngleDoubleRight } from "react-icons/fa";
import ContactForm from '@/components/ContactForm/ContactForm';
import FAQContainer from '@/components/FAQContainer/FAQContainer';
import Footer from '@/components/Footer/Footer';
import AnimatedCopy from '@/components/AnimatedCopy/AnimatedCopy';
import Image from "next/image";
import { Link } from '@/i18n/routing';


const ContactForms: React.FC = () => {

  const posts = [
    { src: "/padlev/1.png", title: "Padlev", link:"/padlev",
      content:" Padlev is an advanced multilingual e-commerce platform featuring a professional, fully responsive design, BTCPay crypto payments, customer points and coupon systems, and automated email marketing. Built with Next.js, TypeScript, Tailwind CSS, Django, and Celery, the platform delivers a fast, scalable, and seamless shopping experience across 10 languages." },
    { src: "/padel-master/5.avif", title: "Padel master the game",link:"/padel-master-the-game",
      content:"Padel Master The Game is a multilingual eBook platform featuring a complete affiliate system, secure Paddle and BTCPay payments, and a large digital pack with downloads in 10 languages. The platform includes affiliate link generation, sales history, earnings tracking, and withdrawals, providing a complete automated digital sales experience."
     },
    { src: "/livside/3.avif", title: "Livside",link:"/livside",
      content:"Livside is a complete real estate brokerage platform available in 4 languages, featuring detailed property listings, weather API integration, property visit appointment scheduling, and a dedicated dashboard to manage and track leads, appointments, and property statuses."
     },
  ]as const;;



  return (
  
  <div className='rounded-b-3xl'>
  {/* Fixed background — stays behind everything while page scrolls */}

  <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative rounded-b-3xl"
    style={{ backgroundImage: `url('/case.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55  h-96 lg:h-[500px] rounded-b-3xl" />
  <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
    Case Studies
  </h1>
    
  </div>

  <NavBar />


 <div className="p-6 md:p-12 lg:p-24">
      <div className="flex justify-center lg:justify-end gap-2 mb-8 lg:-mb-32 flex-wrap items-center bg-white">
        <h2 className="text-4xl lg:text-7xl font-bold">Works</h2>
       
      </div>

<div className="space-y-12 lg:space-y-20 mt-8 lg:mt-12">
  {posts.map((post, i) => {
    const isReversed = i % 2 === 1; // odd indexes flip
    return (
      <div
        key={i}
        className={`group space-y-4 flex flex-col lg:gap-20 cursor-pointer items-center ${
          isReversed ? "lg:flex-row-reverse" : "lg:flex-row"
        }`}
      >
  
        <div className="relative w-full h-64 sm:h-96 lg:h-[700px] rounded-3xl overflow-hidden shadow-lg transition-all duration-500 ease-out group-hover:shadow-2xl group-hover:-translate-y-2">
          <Image
            src={post.src}
            alt="padel-book-alt"
            quality={100}
            fill
            sizes="(max-width: 1024px) 100vw, 50vw"
            className="object-cover rounded-3xl transition-transform duration-700 ease-out group-hover:scale-110"
            priority
          />

          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

          {/* Arrow badge */}
          <div className="absolute top-5 right-5 w-10 h-10 rounded-full bg-white/90 flex items-center justify-center opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 delay-100">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M7 17L17 7" />
              <path d="M7 7h10v10" />
            </svg>
          </div>
        </div>


        <div className="w-full space-y-4 lg:space-y-10 mt-4 lg:mt-0">
          <h4 className="text-3xl lg:text-6xl font-bold transition-colors duration-300 group-hover:text-primary">
            {post.title}
          </h4>
          <p className="text-base lg:text-2xl mt-2">{post.content} {" "} 
      <Link href={post.link}>      
        <span className="inline-flex items-center gap-1 border-b border-current pb-0.5 text-primary">
  View more <FaAngleDoubleRight size={16} />
</span></Link>
</p>
         
        </div>
      </div>
    );
  })}
</div>
    </div>
<ContactForm/>

<Footer/>
</div>
  );
};

export default ContactForms;